export const GET_TARIFFS_REQUEST = "GET_TARIFFS_REQUEST"
export const GET_TARIFFS_REQUEST_SUCCESS = "GET_TARIFFS_REQUEST_SUCCESS"

export const GET_TARIFF_REQUEST = "GET_TARIFF_REQUEST"
export const GET_TARIFF_REQUEST_SUCCESS = "GET_TARIFF_REQUEST_SUCCESS"

export const UPDATE_TARIFFS_REQUEST = "UPDATE_TARIFFS_REQUEST"
export const UPDATE_TARIFFS_REQUEST_SUCCESS = "UPDATE_TARIFFS_REQUEST_SUCCESS"
